import React, { useEffect } from 'react'
import { AppDispatch, StoreState } from '../../state/configureStore'
import { connect, useDispatch } from 'react-redux'
import { AnyAction, Dispatch } from 'redux'
import Page from '../../components/molecules/page'
import { fetchMachines } from '../../state/actions/machine'
import { DataLoadingText } from '../../components/atoms/text/dataLoadingText'
import OverviewMap from './overviewMap'
import { Box } from '@mui/material'
import theme from '../../theme'
import { fetchNodeColors } from '../../state/thunks/nodes'
import { fetchCustomers, fetchCustomer, fetchStores } from '../../state/actions/customer'

function DashboardPage(
  state: ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>
): React.ReactElement {
  const dispatch = useDispatch<AppDispatch>()
  
  useEffect(() => {

    state.fetchMachines( "dashboard_view")
    //TODO: Need some easier and faster way to fetch stores and customer information that this:
    if (state.customers.stores.length === 0){
      state.fetchStores()
    }
    
    dispatch(fetchNodeColors())
  }, [])


  // Reload browser if it's open at 2am.
  // In order to get a clear refresh everyday if it's on a public "kiosk".
  useEffect(() => {
    const now = new Date()
    const reloadTime = new Date()

    // Set reload time to 2:00 AM today
    reloadTime.setHours(2, 0, 0, 0)

    // If it's past 2:00 AM, set reload for 2:00 AM tomorrow
    if (now >= reloadTime) {
      reloadTime.setDate(reloadTime.getDate() + 1)
    }

    const timeUntilReload = (reloadTime.valueOf() - now.valueOf())
    console.log('time until reload', timeUntilReload)

    // Schedule the reload
    const timeoutRef = setTimeout(() => {
      document.location.reload()
    }, timeUntilReload);

    return () => clearTimeout(timeoutRef)
  }, [])


  if (state.machineFetchingState === 'loading' || state.storeFetchingState === 'loading') {
    return(
      <Page hideBreadcrumbs fullView>
        <Box key={'loadingContainer'} sx={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: theme.palette.primary.light}}>
          <DataLoadingText key={'loadingText'} showSpinner />
        </Box> 
      </Page>
    )      
  }
  
  if (state.machineFetchingState === 'failed' || state.storeFetchingState === 'failed') {
    return (
      <Page hideBreadcrumbs fullView>
        <DataLoadingText text={'There was an issue loading data from the server.'} /> 
      </Page>
    )
  }

  return(
    <Page hideBreadcrumbs fullView>
      <OverviewMap />
    </Page>
  )
}

const mapStateToProps = (state: StoreState) => ({
  signalRLogs: state.signal_r_logs,
  machines: state.machines,
  machineFetchingState: state.machine_fetching,
  customers: state.customers,
  storeFetchingState: state.stores_fetching
})

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => ({
  fetchMachines: (prop) => dispatch(fetchMachines(prop)),
  fetchStores: () => dispatch(fetchStores()),
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage)